import type { CatalogueDesignKey } from '@eshop/designs';

import { templateRegistry } from './system/TemplateRegistry';
import type { CatalogueTemplateLoader } from './system/TemplateRegistry';
import type { VisualTemplate } from './system/templateTypes';

const catalogueLoaders: Record<string, CatalogueTemplateLoader> = {
  classic: () => import('./classic'),
  'sidebar-filters': () => import('./sidebar-filters'),
  'topbar-filters': () => import('./topbar-filters'),
  masonry: () => import('./masonry'),
};

Object.entries(catalogueLoaders).forEach(([name, loader]) => {
  templateRegistry.registerCatalogueLoader(name, loader);
});

const visualTemplateLoaders: Partial<Record<CatalogueDesignKey, () => Promise<VisualTemplate>>> = {
  // moderno: () =>
  //   import(/* webpackChunkName: "catalogue-visual-moderno" */ './visual/ModernoTemplate').then(
  //     (mod) => mod.default,
  //   ),
  minimalista: () =>
    import(/* webpackChunkName: "catalogue-visual-minimalista" */ './visual/MinimalistaTemplate').then(
      (mod) => mod.default,
    ),
  // clean: () =>
  //   import(/* webpackChunkName: "catalogue-visual-clean" */ './visual/CleanTemplate').then(
  //     (mod) => mod.default,
  //   ),
  'soft-commerce': () =>
    import(/* webpackChunkName: "catalogue-visual-soft-commerce" */ './visual/SoftCommerceTemplate').then(
      (mod) => mod.default,
    ),
};

Object.entries(visualTemplateLoaders).forEach(([design, loader]) => {
  templateRegistry.registerTemplate(design as CatalogueDesignKey, loader);
});
